export const ApiNames = {
    BASE: 'base',
    PPS: 'pps',
    RESEARCH: 'research',
    LOCAL: 'local',
    IMG: 'img'
};
